function filterListCondition(conditionType, listCondition) {
  if (!listCondition) {
    return []
  }
  const condition = listCondition.filter(item => {
    return item.name === conditionType
  })
  if (condition && condition[0]) {
    return condition[0].data
  }
  return []
}
let conditionMap = new Map()
  .set('融资期限', getApplyDeadline)
  .set('融资类别', getFinancType)
  .set('抗疫融资类别', getEpidemicFinancType)
  .set('担保方式', getGuaranteeMeans)
  .set('申请人与企业关联关系', getApplicantEnterpriseRelationship)

// 根据 id 匹配列表总的 name（订单）
function matchFilterCondition(id, type, listCondition) {
  if (!id || !listCondition) {
    return '暂无信息'
  }
  let result = conditionMap
    .get(type)(listCondition)
    .find(item => {
      return item.id === id
    })
  return (result && result.name) || '暂无信息'
}

// 根据 ids 匹配列表中的 name
function matchMultiFilterCondition(ids, type, listCondition) {
  if (!ids || !listCondition) {
    return '暂无信息'
  }
  ids = ids.split(',')
  let conditionList = conditionMap.get(type)(listCondition)
  let result = conditionList.filter(condition => {
    return ids.indexOf(condition.id) > -1
  })
  return result.length ? result : '暂无信息'
}

// 融资期限
function getApplyDeadline(listCondition) {
  let condition = filterListCondition('融资期限', listCondition)
  condition = JSON.parse(JSON.stringify(condition))
  condition.unshift({ id: -1, name: '手动填写', ext: false })
  return condition
}

// 融资类型
function getFinancType(listCondition) {
  return filterListCondition('融资类别', listCondition)
}

function getEpidemicFinancType(listCondition) {
  return filterListCondition('抗疫融资类别', listCondition)
}

// 担保方式
function getGuaranteeMeans(listCondition) {
  return filterListCondition('担保方式', listCondition)
}
// 申请人与企业关联关系
function getApplicantEnterpriseRelationship(listCondition) {
  return filterListCondition('申请人与企业关联关系', listCondition)
}

// 获取全部地区树形数据
function getFullAreaList(fullAreaList) {
  if (fullAreaList.length === 0) {
    return []
  }
  if (Array.isArray(fullAreaList[0].children)) {
    return fullAreaList
  }
  fullAreaList = fullAreaList.filter(item => {
    return item.name !== '浙江省本级'
  })
  fullAreaList.forEach((item, index) => {
    fullAreaList[index].children = fullAreaList[index].districtList
  })
  return fullAreaList
}
// 格式化支行数据结构
function getFormatedBranchBankList(branchBankList) {
  let newList = []
  branchBankList.forEach(item => {
    newList.push({ id: item.orgId, name: item.orgSimpleName })
  })
  return newList
}

export {
  getApplyDeadline,
  getFinancType,
  getGuaranteeMeans,
  getApplicantEnterpriseRelationship,
  getFullAreaList,
  matchFilterCondition,
  matchMultiFilterCondition,
  getFormatedBranchBankList
}
